export class AutoImportCompletedEvent {
  constructor(public readonly reviewId: number) {}
}
